<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="title" label="展示标题:" :rules="[{ required: true, message: '请填写展示标题' }]">
                    <el-input placeholder="请填写展示标题" v-model.trim="formData.title" maxlength="40" show-word-limit>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="time1" label="展示时间:" :rules="[{ required: true, message: '请设置展示时间' }]">
                    <span slot="label">展示时间：<small><span class="el-icon-warning"></span> 到期后会被自动隐藏</small></span>
                    <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bindIds" label="绑定对象:"
                    :rules="[{ validator: validateBindIds, required: true }]">
                    <span slot="label">
                        绑定对象：
                        <el-checkbox v-model="formData.isBind"
                            @change="formData.isBind ? '' : formData.bindIds = ''" :true-label="0" :false-label="1">
                            不限制ID</el-checkbox>
                    </span>
                    <el-input placeholder="请填写对象ID" v-model="formData.bindIds" maxlength="200"
                        :disabled="!formData.isBind ? true : false">
                    </el-input>
                    <small class="MT10 color-danger">
                        对象ID根据所选广告位，需要填写演出ID/众筹ID/周边ID，多个ID用逗号分隔。如果不限ID请勾选复选框
                    </small>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="link" label="跳转链接:">
                    <el-input placeholder="请填写跳转链接" v-model="formData.link" maxlength="200"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="aliLink" label="支付宝小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="支付宝小程序APPID" v-model="formData.aliLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="支付宝小程序跳转路径" v-model="formData.aliLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="wxLink" label="微信小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="微信小程序APPID" v-model="formData.wxLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="微信小程序跳转路径" v-model="formData.wxLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-form-item prop="content" label="内容说明:">
                    <el-input type="textarea" placeholder="请填写内容说明" v-model="formData.content" maxlength="1000"
                        show-word-limit></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: {
        formData: {
            type: Object,
            default: null
        },
        validateBindIds: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        
    }
}
</script>